/**
 * Zendesk Garden 取向 — 對齊 www.zendesk.com.tw 行銷站風格
 * @see https://zendeskgarden-website.mintlify.app/design/color
 */
export const colors = {
  /* Kale — 品牌主色 */
  kale800: '#012B30',
  kale700: '#03363D',
  kale600: '#17494D',
  kale500: '#467B7C',
  kale200: '#DAEDED',
  kale100: '#F5FCFC',

  /* 科技藍 — 互動 / CTA */
  azure600: '#4A6984',
  azure500: '#5D7F9A',
  azure100: '#E8EDF2',

  /* Grey — 中性 */
  grey800: '#2F3941',
  grey600: '#68737D',
  grey300: '#C2C8CC',
  grey200: '#E9EBED',
  grey100: '#F8F9F9',

  surface: '#FFFFFF',
  textPrimary: '#2F3941',
  textSecondary: '#68737D',
  textOnDark: '#FFFFFF',

  border: '#E9EBED',
  borderFocus: '#4A6984',
  shadowSoft: '0 4px 14px rgba(47, 57, 65, 0.08)',
  shadowCard: '0 8px 24px rgba(47, 57, 65, 0.1)',
};

/** 官網 Hero 常用 Kale 深色遮罩 */
export const BANNER_OVERLAY =
  'linear-gradient(180deg, rgba(3, 54, 61, 0.88) 0%, rgba(23, 73, 77, 0.78) 100%)';

export const pastel = {
  kale: 'rgba(218, 237, 237, 0.6)',
  blue: 'rgba(231, 244, 255, 0.85)',
  grey: 'rgba(248, 249, 249, 0.95)',
};

export const radius = {
  sm: 4,
  md: 8,
  lg: 12,
  pill: 999,
};

/** 快速導覽卡片字級倍率（相對原 0.95rem / 0.875rem） */
const CATEGORY_TAB_FONT_SCALE = 1.15;

/** AI 服務 / 成功案例 — 大分類導覽 tab（白底 → hover 科技藍） */
export const categoryTabLinkSx = {
  display: 'block',
  textDecoration: 'none',
  p: 2,
  borderRadius: `${radius.md}px`,
  border: `1px solid ${colors.border}`,
  backgroundColor: colors.surface,
  transition: 'background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease',
  '&:hover': {
    backgroundColor: colors.azure600,
    borderColor: colors.azure600,
    boxShadow: '0 4px 14px rgba(74, 105, 132, 0.35)',
    '& .category-tab-title': {
      color: colors.textOnDark,
    },
    '& .category-tab-desc': {
      color: 'rgba(255, 255, 255, 0.92)',
    },
  },
};

export const categoryTabTitleSx = {
  fontWeight: 700,
  color: colors.kale700,
  fontSize: `${0.95 * CATEGORY_TAB_FONT_SCALE}rem`,
  mb: 0.5,
  transition: 'color 0.2s ease',
};

export const categoryTabDescSx = {
  color: colors.textSecondary,
  fontSize: `${0.875 * CATEGORY_TAB_FONT_SCALE}rem`,
  lineHeight: 1.5,
  transition: 'color 0.2s ease',
};

/** 成功案例頁 — 1920 解析度排版與卡片尺寸 */
export const successCaseTypography = {
  heroTitle: { fontSize: '28px', fontWeight: 700, lineHeight: 1.3 },
  heroBody: { fontSize: '16px', fontWeight: 400, lineHeight: 1.75 },
  sectionTitle: { fontSize: '26px', fontWeight: 700, lineHeight: 1.3, color: colors.kale700 },
  sectionCount: { fontSize: '18px', fontWeight: 500, lineHeight: 1.5, color: colors.textSecondary },
  blockLabel: { fontSize: '19px', fontWeight: 500, lineHeight: 1.4, color: colors.kale600 },
  body: { fontSize: '16px', fontWeight: 400, lineHeight: 1.75, color: colors.textPrimary },
  cardTitle: { fontSize: '18px', fontWeight: 700, lineHeight: 1.45, color: colors.kale700 },
  cardSecondary: { fontSize: '14px', fontWeight: 400, lineHeight: 1.5, color: '#6B7280' },
};

export const successCaseCard = {
  width: 270,
  minHeight: 320,
  gap: 24,
  logoHeight: 150,
};
